import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CLOSE_BUTTON: `${cleanedFilename(__filename)}-close-button`,
};
